<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg729"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs733"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath743"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path741" /></clipPath></defs><g
     id="g735"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g737"><g
         id="g739"
         clip-path="url(#clipPath743)"><g
           id="g745"
           transform="translate(442,322)"><path
             d="M 0,0 V -142"
             style="fill:none;stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path747" /></g><g
           id="g749"
           transform="translate(492,272)"><path
             d="m 0,0 -208.389,209.763 c -15.154,13.606 -38.111,13.654 -53.322,0.112 L -472,0"
             style="fill:none;stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path751" /></g><g
           id="g753"
           transform="translate(70,319)"><path
             d="m 0,0 v -239 c 0,-33.137 26.863,-60 60,-60 h 252 c 33.137,0 60,26.863 60,60"
             style="fill:none;stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path755" /></g><g
           id="g757"
           transform="translate(256,100)"><path
             d="m 0,0 c -22.091,0 -40,17.909 -40,40 0,22.091 17.909,40 40,40 22.091,0 40,-17.909 40,-40"
             style="fill:none;stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path759" /></g><g
           id="g761"
           transform="translate(256,362)"><path
             d="M 0,0 V -180.8"
             style="fill:none;stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path763" /></g><g
           id="g765"
           transform="translate(256,322)"><path
             d="M 0,0 H 40"
             style="fill:none;stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path767" /></g><g
           id="g769"
           transform="translate(256,252)"><path
             d="M 0,0 H 40"
             style="fill:none;stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path771" /></g></g></g></g></svg>
</template>
